import { Flex, FlexProps } from '@chakra-ui/react';
import { UserDetailsTabs } from './components/UserDetailsTabs';

const UserDetailsData = (props: FlexProps): JSX.Element => (
  <Flex
    direction="column"
    w="100%"
    borderRadius={8}
    bg="white"
    p="8"
    {...props}
  >
    <UserDetailsTabs />
  </Flex>
);

export default UserDetailsData;
